import { DARK_MODE } from "./dark-mode";

export const Google = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{DARK_MODE}</style>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6801 8.1818C15.6801 7.61453 15.6292 7.06908 15.5346 6.54544H8.00006V9.63999H12.3055C12.1201 10.64 11.5564 11.4873 10.7092 12.0545V14.0618H13.2946C14.8073 12.6691 15.6801 10.6182 15.6801 8.1818Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00001 16C10.16 16 11.9709 15.2836 13.2946 14.0618L10.7091 12.0545C9.99274 12.5345 9.07638 12.8182 8.00001 12.8182C5.91638 12.8182 4.15274 11.4109 3.52365 9.52H0.850922V11.5927C2.16729 14.2073 4.87274 16 8.00001 16Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.52364 9.51998C3.36364 9.03998 3.27273 8.52726 3.27273 7.99998C3.27273 7.47271 3.36364 6.95998 3.52364 6.47998V4.40726H0.850909C0.309091 5.48726 0 6.70908 0 7.99998C0 9.29089 0.309091 10.5127 0.850909 11.5927L3.52364 9.51998Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00001 3.18182C9.17456 3.18182 10.2291 3.58545 11.0582 4.37818L13.3527 2.08364C11.9673 0.792727 10.1564 0 8.00001 0C4.87274 0 2.16729 1.79273 0.850922 4.40727L3.52365 6.48C4.15274 4.58909 5.91638 3.18182 8.00001 3.18182Z"
      fill="#EA4335"
    />
  </svg>
);
